<template>
  <div>
    <div id="informacoes-medico">
      <el-row>
        <el-col :span="12">
          <el-col :span="8">
            <img v-if="medicoSelecionado.urlFoto" class="img-circle" :src="medicoSelecionado.urlFoto"/>
          </el-col>
          <el-col :span="16">
            <div class="info-medico">
            <span class="big-text-bold">{{medicoSelecionado.nome}}</span>
            <span class="md-text-bold">{{medicoSelecionado.conselho}}</span>
            <span class="md-text-bold">{{medicoSelecionado.especialidade.descricao}}</span>
            <span class="md-text-regular">{{labelTipoServico}}</span>
            <span class="sm-text-regular">{{medicoSelecionado.localAtendimento.descricao}}</span>
            </div>
          </el-col>
        </el-col>
        <el-col :span="12">
          <div class="dados-medico" v-if="idAgenda === '1' && local && local.endereco">
            <div class="svg">
              <inline-svg :src="require('@/assets/icons/icon_mini_map.svg')"></inline-svg>
            </div>
            <div class="text-endereco">
              <span class="endereco" v-html="fullEndereco(local.endereco)"></span>
              <el-button @click="verMapa" class="btn-text" type="text">VER NO MAPA</el-button>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
   <div style="margin-top:47px" id="tabs">
     <agendaTab :initial-value="active" :initial="2" v-model="selected" :itens="horariosMedico"/>
     <div class="agenda-disponivel" v-if="horariosDia">
      <span class="sm-text-regular bold">{{horariosDia.length}} horários disponíveis</span>
       <div v-for="(item, i) in horariosPeriodo" :key="i">
         <el-card v-show="item.length" :style="`background: ${corPrimariaAlpha}`" class="card-horarios-medico">
           <span class="bold capitalize">{{i}}</span>
         <div style="display: inline-block;width: 614px;">
           <el-button
             class="btn"
             v-for="(horario, i) in item"
             @click.stop="nextStep(medicoSelecionado, horario)"
             :style="`background: ${corPrimaria}`"
             :key="i">
             {{formatHora(horario.dataHora)}}
           </el-button>
         </div>
       </el-card>
       </div>
     </div>
   </div>
  </div>
</template>
<script>
import AgendaTab from '@/components/AgendaTab/AgendaTab'
import { mapActions, mapGetters, mapState } from 'vuex'
import moment from 'moment'
import inlineSvg from 'vue-inline-svg'
export default {
  name: 'medico-detalhe',
  data () {
    return {
      horariosDia: null,
      selected: this.active,
      data: null,
      open: false
    }
  },
  props: {
    agenda: {},
    active: {}
  },
  components: {
    AgendaTab,
    inlineSvg
  },
  watch: {
    medicoSelecionado: function () {
      this.getAgendaDia(this.active)
    },
    selected: {
      handler (newValue) {
        this.getAgendaDia(newValue)
      },
      immediate: true
    }
  },
  computed: {
    ...mapState('SetupApp', ['apiFuncionalidade']),
    ...mapState('Func53', ['paciente', 'idEspecialidade', 'idLocal', 'local', 'idAgenda']),
    ...mapGetters('SetupApp', ['estilo']),
    ...mapGetters('Func53', ['tipoServico', 'idServico']),
    corPrimariaAlpha () {
      return this.estilo.aplicacao.corPrimariaAplicacao + '1A'
    },
    corPrimaria () {
      return this.estilo.aplicacao.corPrimariaAplicacao
    },
    corBotaoSecundario () {
      return this.estilo.botaoSecundario.corBotaoSecundario
    },
    medicoSelecionado () {
      return this.agenda[0].profissionais[0]
    },
    horariosMedico () {
      const items = []
      this.agenda.forEach(el => items.push(el.data))
      return items
    },
    horariosPeriodo () {
      const obj = {
        manhã: [],
        tarde: [],
        noite: [],
        madrugada: []
      }

      const format = this.horariosDia.map(el => moment(el.dataHora).format('HH'))

      format.forEach((el, i) => {
        if (el >= 6 && el < 12) {
          obj.manhã.push(this.horariosDia[i])
        } else if (el >= 12 && el <= 17) {
          obj.tarde.push(this.horariosDia[i])
        } else if (el >= 18 && el <= 23) {
          obj.noite.push(this.horariosDia[i])
        } else {
          obj.madrugada.push(this.horariosDia[i])
        }
      })
      return obj
    },
    labelTipoServico () {
      if (this.idServico) {
        return this.tipoServico.find(item => item.idServico === this.idServico).descricao
      }
      return ''
    }
  },
  methods: {
    ...mapActions('Func53', ['setAgendamento']),
    getAgendaDia (date) {
      const agendaDia = this.agenda.find(agendaItem => agendaItem.data === date)
      if (agendaDia) {
        this.horariosDia = agendaDia.profissionais[0].horarios
      } else {
        this.horariosDia = this.agenda[0].profissionais[0].horarios
      }
    },
    fullEndereco (endereco) {
      if (endereco) {
        return `${endereco.endereco}, ${endereco.numero} </br> ${endereco.cidade}, ${endereco.bairro}`
      }
      return ``
    },
    verMapa () {
      window.open(`https://maps.google.com/?q=${this.local.endereco.endereco},${this.local.endereco.numero},${this.local.endereco.bairro}, ${this.local.endereco.cidade}`)
    },
    nextStep (item, hora) {
      const obj = { ...item, ...hora }
      delete obj.horarios
      this.setAgendamento(obj)
      this.$router.replace({ query: { step: 6 } })
    },
    formatHora (val) {
      return moment(val.toString()).format('HH:mm')
    }
  },
  mounted () {
    this.getAgendaDia(this.active)
  }
}
</script>
